export const UPLOAD_PRODUCTS_GOOGLE_SHEET_URL =
  'https://docs.google.com/spreadsheets/d/1lGTvoGt9qeIo0kL1Szmn5JOXTi-TFwOBjf4gwRfbKYU/edit?gid=77446419#gid=77446419';
export const UPLOAD_PRODUCTS_XLSX_URL = 'https://cdn.cym.bio/files/cymbio-taxonomy-for-brands.xlsx';

export const fieldsThatRequiredMathTransformer = ['retail_price', 'wholesale_price'];
export const priceMathTransformer = 'round(x * 100)';

export const availableFields = [
  'option',
  'property',
  'sku',
  'model',
  'upc',
  'ean',
  'id_in_source',
  'weight',
  'images',
  'product_page_url',
  'supplier_id',
];

export const multiLanguageAvailableFields = [
  'title',
  'description',
  'description_extra',
  'description_bullets',
  'bullet_1',
  'bullet_2',
  'bullet_3',
  'bullet_4',
  'bullet_5',
  'bullet_6',
  'bullet_7',
  'additional_information',
  'material_description',
  'sustainability_details',
  'warranty',
  'color',
  'strap_length',
];

export const availableOptions = ['color', 'size'];

export const availableProperties = [
  'category',
  'sub_category',
  'material',
  'base_color',
  'care_instructions',
  'country_of_origin',
  'year',
  'season',
  'designer',
  'gender',
  'type',
  'collection',
  'department',
  'feather',
  'weight',
  'width',
  'height',
  'length',
  'surface',
  'style',
  'heel_height',
  'shape',
  'state',
  'shoe_height',
  'lining_material',
  'age_group',
  'size_type',
  'sub_type',
  'subtype',
  'closure',
  'upper_material',
  'import_description',
  'package_depth',
  'package_height',
  'package_weight',
  'package_width',
  'package_length',
  'prop_65',
  'size_group',
  'sleeve_length',
  'torso_length',
  'pattern',
  'neckline_type',
  'defectives',
  'disclaimers',
  'fill_material',
  'outsole_material',
  'material_percentage',
  'export construction_details',
  'depth',
  'min_weight_cap',
  'max_weight_cap',
  'cpsc',
  'certifications',
  'configuration',
  'suggested_age',
  'number_of_pieces',
  'assembly_details',
  'number_wheels',
  'cropped_top',
  'occasion',
  'top_height',
  'logistics_class',
  'sport_type',
  'bottoms_fit_type',
  'bra_style',
  'jacket_type',
  'shorts_type',
  'technology',
  'cover_sole_material',
  'fit',
  'base_material',
  'inner_material',
  'family_color',
  'hs_code',
  'model_color',
  'size_system',
  'brand_color_code',
  'hex_color_code',
  'nrf_color_code',
  'nrf_size_code',
  'material_1',
  'material_1_percentage',
  'material_2',
  'material_2_percentage',
  'material_3',
  'material_3_percentage',
  'material_4',
  'material_4_percentage',
  'material_5',
  'material_5_percentage',
  'material_6',
  'material_6_percentage',
  'material_7',
  'material_7_percentage',
  'material_8',
  'material_8_percentage',
  'material_9',
  'material_9_percentage',
  'material_10',
  'material_10_percentage',
  'lining_material_percentage',
  'dry_instructions',
  'wash_instructions',
  'fabrication',
  'sleeve_type',
  'neckline',
  'collar_type',
  'measurement',
  'body_length',
  'pants_inseam',
  'leg_opening',
  'sole_height',
  'heel_type',
  'toe_shape',
  'shaft_height',
  'shaft_circumference',
  'width_description',
  'platform_height',
  'waist_placement',
  'fabric_weight',
  'silhouette',
  'stretch',
  'hooded',
  'pockets',
  'sustainability',
  'denim_wash',
  'cuff_type',
  'technical_fabrication',
  'boxes_per_item',
  'max_per_box',
  'fit_description',
  'dimensions',
  'additional_information',
  'material_description',
  'sustainability_details',
  'warranty',
  'cites',
  'mid',
  'uv_protection',
  'lens_type',
  'lens_color',
  'occasion',
  'strap_length',
  'size_chart',
  'cpc',
  'test_report',
  'cpsia',
].sort((a, b) => a.localeCompare(b));

export const transformers = {
  string: ['uppercase', 'capitalize', 'lowercase', 'capitalize-first', 'split_by_li', 'split_by_line'],
  string_with_value: ['split_by_character', 'regex'],
  math: ['math'],
};

export const supportedLanguages = [
  'ar',
  'hy',
  'be',
  'bg',
  'ca',
  'zh',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'et',
  'fi',
  'fr',
  'de',
  'el',
  'he',
  'hu',
  'is',
  'id',
  'ga',
  'it',
  'ja',
  'kv',
  'ko',
  'lv',
  'lt',
  'lb',
  'mk',
  'ms',
  'ml',
  'nb',
  'no',
  'pl',
  'fa',
  'pt',
  'ro',
  'ru',
  'sv',
  'es',
  'su',
  'sw',
  'ss',
  'tr',
  'ty',
  'th',
  'uk',
  'vi',
  'cy',
  'zu',
  'gr',
];

export const allPossibleFields = [
  ...availableFields,
  ...multiLanguageAvailableFields,
  ...availableOptions,
  ...availableProperties,
];
